export default __webpack_public_path__ + "static/danny_peeters-000e3cb262fe998663e438a19700c706.jpg";